import { PlayerComponentCSSStyleImpl } from '../../../../toolkit/player/playercss';

export class BannerCardPlayerCSSStyleImpl extends PlayerComponentCSSStyleImpl
{
    getPlayDivCSSStyle(): object 
    {
        return {
            // display: "flex",
            // textAlign: "center",
            // alignItems: 'center', 
            // justifyContent: 'center', 
            // position: "absolute",
            // marginTop: "20px",
            top:'160px',
            right:'30px',
            // marginLeft: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"0px":'30px',
            // marginRight: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"30px":'0px',
            cursor: "pointer",
            width: "70px",
            height: "70px",
            position:'absolute'
        };
    }

    getPlayIconCSSStyle(): object 
    {
        return {
            cursor: "pointer",
            height: "70px",
            width: "70px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannercard/bannercardplayercss.tsx